import classNames from 'classnames';

export const PebbleColourfulLogo = ({
  className = '',
  color = '#4378FF',
  width = 39,
  height = 39,
  ...props
}) => (
  <svg
    className={classNames('icon', className)}
    width={width}
    height={height}
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2642 15.3985C11.2642 15.3985 13.1554 13.7381 17.4943 13.67C21.8331 13.6019 26.5874 14.3035 28.2964 16.1274C30.0054 17.9513 28.9296 19.4891 28.9296 19.4891C28.9296 19.4891 28.1279 20.8634 26.5738 21.221C25.0197 21.5786 23.2324 21.9703 20.7863 21.9856C18.3402 22.001 13.1792 21.72 12.0098 20.7067C10.8404 19.6934 10.0591 18.8607 10.0642 17.7265C10.0693 16.5923 11.2642 15.3985 11.2642 15.3985Z"
      fill="#FA7BBF"
    />
    <path
      d="M14.5494 6.02389C15.7811 5.22407 17.2209 4.80473 18.6892 4.81818C21.1029 4.86076 21.8876 5.341 21.8876 5.341C21.8876 5.341 23.5115 6.35086 23.949 6.48029C24.3864 6.60971 25.1558 6.87708 25.4265 7.66215C25.6971 8.44722 26.0801 9.33106 25.4741 9.85557C24.8681 10.3801 24.6758 10.6628 23.3089 11.0272C22.1611 11.3126 20.9755 11.4155 19.7956 11.332C18.8815 11.2895 16.7231 11.0681 15.9725 11.0664C15.2218 11.0647 13.826 10.2558 13.6524 9.30381C13.4788 8.35185 13.5094 6.47347 14.5494 6.02389Z"
      fill="#ABEE56"
    />
    <path
      d="M8.65645 27.834C8.65645 27.834 9.50755 26.0289 12.6072 24.9901C15.1087 24.1693 17.7768 23.9936 20.3642 24.4792C22.2366 24.8113 25.0265 25.2285 27.767 26.2026C30.5075 27.1767 31.248 27.7659 31.2293 29.0976C31.2105 30.4294 29.8556 31.4818 29.4386 31.6521C27.8846 32.3831 26.1936 32.7767 24.4767 32.8067C21.6476 32.8919 15.2627 32.977 14.1767 32.8953C13.0907 32.8135 10.4318 32.725 9.36797 31.3166C8.3041 29.9083 8.13558 28.6855 8.65645 27.834Z"
      fill="#548CED"
    />
  </svg>
);
